export var UnitSize;
(function (UnitSize) {
  UnitSize["ICON_SMALL"] = "16px";
  UnitSize["ICON_MEDIUM"] = "24px";
  UnitSize["ICON_LARGE"] = "48px";
  UnitSize["FIELD_HEIGHT"] = "36px";
  UnitSize["COMPACT_HEIGHT"] = "28px";
  UnitSize["PAGE_WIDTH"] = "980px";
  UnitSize["DRAWER_PADDING"] = "40px";
  UnitSize["SECTION_PADDING"] = "24px";
  UnitSize["POPUP_PADDING"] = "24px";
})(UnitSize || (UnitSize = {}));